
export enum PricePer {
	Child = 0,
	Party = 1
}
